var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSixSenseLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_5026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8796 11.0864C19.1249 11.3467 20.3368 11.8315 21.4514 12.5464L17.7573 16.9112H17.7559C15.7547 15.9994 13.31 16.4815 11.8257 18.2348C10.3414 19.9868 10.2872 22.4578 11.5408 24.2525L7.8454 28.6174C4.23336 24.7677 3.99848 18.7637 7.49518 14.6331L19.8851 0L24.2156 3.60179L17.8796 11.0864Z",
    fill: "#00B3AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8377 28.2233C20.3396 32.354 14.3343 33.168 9.88147 30.31L13.5769 25.9452C15.5782 26.857 18.0242 26.3763 19.5071 24.6229C20.9914 22.8695 21.0456 20.3986 19.792 18.6039L23.4874 14.239C27.0995 18.0887 27.3357 24.0926 23.8377 28.2233Z",
    fill: "#F3EFEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_5026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixSenseLogoWhite);
export default __webpack_public_path__ + "static/media/six-sense-logo-white.6ff2c8eac698d1149c10e114dd0b48b6.svg";
export { ForwardRef as ReactComponent };